module.exports = __webpack_public_path__ + "static/img/pingjieshen1.d4afcac4.png";